// extracted by mini-css-extract-plugin
export var orderDetails = "_po-2";
export var orderImage = "_po-1";
export var orderMeta = "_po-3";
export var orderSummary = "_po-0";
export var rightArrow = "_po-4";